export default __webpack_public_path__ + "static/media/simplehold-wallet.b20c5789.png";